import React from "react";
import Verify from "../Components/user/Verify";

const VerifyUserPage = () => {
  return (
    <div>
      <Verify />
    </div>
  );
};

export default VerifyUserPage;
